// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getImageProviderListFailed, getImageProviderListRequested, getImageProviderListSucceeded } from './select-image-provider.actions';
import { DictionariesService } from '@par/app/core/data-services/dictionaries.service';
import { Store } from '@ngrx/store';
import { selectImageProviderListResponse } from './select-image-provider.selectors';

@Injectable()
export class SelectImageProviderEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getImageProviderListRequested),
      withLatestFrom(this.store.select(selectImageProviderListResponse)),
      filter(([, response]) => response == null),
      switchMap(() => this.service.getImageProviderList()
        .pipe(
          map((response) => getImageProviderListSucceeded({response})),
          catchError(() => of(getImageProviderListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: DictionariesService,
    private store: Store,
  ) {
  }
}
